//DEFINED Z-INDEXES SO WE CAN KEEP OUR HEADS STRAIGHT

export const MapOverlayContainers = 200
export const PubsubCursor = 900
export const PDFSnapshot = 1400
export const InspectorPanel = 1450
export const PubsubPanel = 1600
export const LiveVideo = 2500
export const LiveVideoMap = 2500
export const Footer = 3000
export const MapLayerManager = 3900
export const FloatingSidePanel = 3950
export const SidePanel = 4000
export const AircraftDetailPanel = 4050
export const Navbar = 4500
export const PDFTopBar = 4500
export const HighPriorityModal = 5000
export const HighPriorityModalDropdown = 5500
export const GlobalNotification = 6000
export const PortalledTooltip = 7000
export const SystemInitializing = 10000
